import styled from 'styled-components';

const SPACING = 10;

const AttachmentSliderContainer = styled.div`
  width: 100%;
  margin: ${SPACING}px 0;

  .slick-track {
    min-width: 100%;
    display: flex;
    align-items: center;

    & .slick-slide {
      height: ${({ $maxHeight }) => $maxHeight};
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  ul {
    margin-bottom: 10px;
  }
`;

const AttachmentCard = styled.div`
  max-height: ${({ $maxHeight }) => $maxHeight};
  align-items: center;
  margin: 0;
  padding: 0 ${SPACING}px;
  max-width: 100%;
`;

export {
  AttachmentSliderContainer,
  AttachmentCard,
};
